export default "/images/vendor/@coreui/icons/svg/flag/cif-gy.svg?5c73348986cfcb684fc5045ed05a9941";